// extracted by mini-css-extract-plugin
export default {"mobileNavbar":"MobileNavbar_mobileNavbar__rf-AA","navItem":"MobileNavbar_navItem__LMh0h","active":"MobileNavbar_active__XPNNC"};